<script setup>
import { ref, onMounted } from "vue";
import { requestAnimationFrameCycle } from "@zyzgroup/core-web";
import Stats from "../../vendors/stats/stats.js";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const el = ref();

onMounted(() => {
  const stats = new Stats();
  stats.domElement.style.margin = "1em";
  el.value.appendChild(stats.domElement);
  requestAnimationFrameCycle(() => {
    stats.update();
    return true;
  });
});

defineExpose({});
</script>

<template>
  <div ref="el"></div>
</template>
